import React, {useMemo} from "react"


export default function RescuesInfo(params) {

    const {data} = params
    
    if (!data) return <h2>Nema podataka</h2>
    
    return <div id="rescues-info">
        <h2>Ukupno povreda</h2>
        
        <ul>
            {Object.entries(data)
                .filter(([area, rescues]) => area != '-')
                .sort(([, rescuesA], [, rescuesB]) => rescuesB - rescuesA)
                .map(([area, rescues]) => <li key={area}>{area}: {rescues}</li>)
            }
        </ul>
    </div>
       
}